/**
 * 2019/1/15
 * 作者:lzq
 *功能: 行为日志模块
 */
export default {
  $getway: 'sysapi',
  getOperateLogList: 'operateLog/list'
};
